import React from 'react';
import { Route, Routes, Navigate } from "react-router-dom";
import Layout from '../../Checkout/Layout/layout';
import { CheckoutProvider, useCheckoutContext } from "../../../context/experienceCheckoutContext";
import Loader from '../../../components/Loader/Loader';
import Billing from './Billing';
import Payments from './Payments';
import Passengers from './Passengers';

import BookingQuestions from './BookingQuestions/BookingQuestions'
import Enjoy from './Enjoy';

const CheckoutComponent = ({ children }: { children: React.ReactNode}) => {
  const { order, loading } = useCheckoutContext();
  if (loading || !order) {
    return <Loader />;
  }

  return children;
};

const Checkout = () => {
  return (
    <CheckoutProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="passengers" element={
            <CheckoutComponent>
              <Passengers />
            </CheckoutComponent>
          } />
          <Route path="booking-questions" element={<BookingQuestions />} />
          <Route path="billing" element={
            <CheckoutComponent>
              <Billing />
            </CheckoutComponent>
          } />
          <Route path="payments" element={
            <Payments />
          } />
          {/* Does not receive CheckoutComponent since that context get's lost while redirecting back from MercadoPago */}
          <Route path="enjoy" element={ <Enjoy />} />
          <Route path="*" element={<Navigate to="/home" />} />
        </Route>
      </Routes>
    </CheckoutProvider>
  );
};

export default Checkout;
